import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { PaibanTaskRow, PaibanTaskStatusEnum } from '../types'
import type { StatusOptionItem } from '../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-paiban-task-status-cell',
  props: {
    text: null,
    record: null,
    statusOptions: null
  },
  setup(__props: any) {

const props = __props as {
  text: number
  record: PaibanTaskRow
  statusOptions: StatusOptionItem[]
}



const statusLabelMap = computed(() => {
  const map: Record<string, string> = {}
  props.statusOptions.forEach((item) => {
    map[item.value] = item.label
  })
  return map
})

function statusLabel(status: number): string {
  return statusLabelMap.value[String(status)] || String(status)
}

function statusClass(status: PaibanTaskStatusEnum): string {
  return `paiban-task-list__status--${status}`
}

function getClassByStatus(
  status: PaibanTaskStatusEnum,
  text: number
): string[] {
  const classList = [statusClass(text)]
  if (status === PaibanTaskStatusEnum.FAILED) {
    classList.push('icon-warning')
  } else if (status === PaibanTaskStatusEnum.COMPLETED) {
    classList.push('icon-a-Frame2')
  }
  return classList
}

function getProgressColor(status: PaibanTaskStatusEnum): string {
  switch (status) {
    case PaibanTaskStatusEnum.FAILED:
      return '#cf1322'
    case PaibanTaskStatusEnum.COMPLETED:
      return '#159c49'
    case PaibanTaskStatusEnum.PENDING:
      return '#1890ff'
    case PaibanTaskStatusEnum.RUNNING:
      return '#18a8c7'
    case PaibanTaskStatusEnum.PAUSED:
      return '#18a8c7'
    default:
      return '#18a8c7'
  }
}

function getProgressStatus(status: PaibanTaskStatusEnum): string {
  switch (status) {
    case PaibanTaskStatusEnum.FAILED:
      return 'exception'
    case PaibanTaskStatusEnum.COMPLETED:
      return 'success'
    default:
      return 'active'
  }
}

return { __sfc: true,props, statusLabelMap, statusLabel, statusClass, getClassByStatus, getProgressColor, getProgressStatus, PaibanTaskStatusEnum }
}

})